var map = {
	"./001-Lamborghini_Logo.svg.png": 8547,
	"./002-Volkswagen_logo_2019.svg.png": 798,
	"./003-audi-logo.png": 1565,
	"./004-seat.png": 5319,
	"./005-Bentley-Logo.png": 7813,
	"./006-skoda-logo-603B0DB338-seeklogo.com.png": 8464,
	"./007-Pivotal_Software_logo.svg.png": 8705,
	"./008-OpenStack-Logo-Horizontal.png": 8115,
	"./009-Google_2015_logo.svg.png": 5716,
	"./010-Amazon_Web_Services_Logo.svg.png": 8765,
	"./011-voksbanken-logo.png": 7027,
	"./012-MongoDB_Logo.svg.png": 1768
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8358;